import {
  Box,
  Button as MuiButton,
  Chip as MuiChip,
  Stack,
  styled,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';

export const Wrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`;

export const HeaderWrapper = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const ActionButtonsContainer = styled(Stack)`
  flex-shrink: 0;
`;

export const Button = styled(MuiButton)<{ btncolor?: string }>`
  max-height: 40px;
  color: ${(props: { btncolor: string }) =>
    props.btncolor ? props.btncolor : 'undefined'};
`;

export const CustomTableHead = styled(TableHead)(
  ({ theme }) => `
      th {
        border-bottom: 2px solid ${theme.palette.brand.black}; 
        font-weight : 700; 
      }
    `,
);

export const CustomTableCell = styled(TableCell)<{
  width: number;
  isChildRow: boolean;
}>`
  width: ${(props: { width: number }) => `${props.width}px`};
  border: ${(props: { isChildRow: boolean }) => props.isChildRow && `none`};
  padding: ${(props: { isChildRow: boolean }) => props.isChildRow && '0 0 0 0'};
`;
export const LinkContainer = styled(Button)`
  padding-left: 14px;
  padding-right: 0;
`;
export const Chip = styled(MuiChip)(
  ({ theme }) => `
    background-color: transparent;
    color: ${theme.palette.success.main};
    };
  `,
);

export const TableRowContainer = styled(TableRow)(
  ({ theme }) => `
    background-color: ${theme.palette.brand.antiFlash}; 
    `,
);
